import { z } from "zod";
export const IdSchema = z.string().uuid();
export const IsoDateTimeSchema = z.string().datetime({ offset: true });
export const Sha256Schema = z.string().regex(/^sha256:[a-f0-9]{64}$/);
export const IdempotencyKeySchema = z.string().min(8).max(128);
/** A time zone this runtime's Intl knows, by IANA name (a clinic's clock). */
export const IanaTimeZoneSchema = z
    .string()
    .trim()
    .min(1)
    .max(100)
    .superRefine((value, context) => {
    try {
        new Intl.DateTimeFormat("en", { timeZone: value });
    }
    catch {
        context.addIssue({
            code: "custom",
            message: "Timezone must be a supported IANA timezone",
        });
    }
});
export const JsonValueSchema = z.lazy(() => z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
    z.array(JsonValueSchema),
    z.record(z.string(), JsonValueSchema),
]));
//# sourceMappingURL=primitives.js.map